/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { list2 } from '~/actions/orderNew';
import { Button } from 'react-toolbox/lib/button';
import Order from '~/components/Order';
import Spinner from '~/components/Spinner';

import styleLocal from './style.scss';

class OrderPage extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      results: [],
      query: '',
    };
  }

  componentDidMount() {
    this.search();
  }

  search() {
    this.setState({ loading: true });
    list2(this.props.dispatch, this.context.apiClient, this.state.query)
      .then(r => this.setState({
        results: r.data.results,
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  }

  loadMore() {
    this.setState({ loading: true });
    list2(this.props.dispatch, this.context.apiClient, this.state.query, this.state.skipId)
      .then(r => this.setState({
        results: [...this.state.results, ...r.data.results],
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        <div className={styleLocal.header}>
          <div className={styleLocal.title}>Orders (new)</div>
          <Button
            label="New Order"
            primary
            raised
            className={styleLocal.buttonNew}
            onClick={() => this.context.dialogPush('orderNew', { onCreate: () => this.search() })}
            icon="add"
          />
        </div>
        <form style={{ marginBottom: 15 }} onSubmit={e => { e.preventDefault(); this.search(); }}>
          <input
            placeholder="Search Reference, SKU or ID"
            className={styleLocal.searchField}
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value, skipId: null })}
          />
          <Button label="Find" primary raised type="submit" />
        </form>

        {this.state.loading && <div><Spinner /></div>}
        {!this.state.loading && this.state.results.length === 0 && 'No Orders found'}
        {!this.state.loading && <div>
          {Object.values(this.state.results).map(order => <div key={order.id} style={{ display: 'inline-block', margin: '0px 5px 0px 0px' }}>
            <Order id={order.id} />
          </div>)}
        </div>}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(OrderPage);



// WEBPACK FOOTER //
// ./app/pages/Order/index.js